// Styles
import './VCalendarWeekly.sass'

// Mixins
import VCalendarWeekly from './VCalendarWeekly'

// Util
import { parseTimestamp, getStartOfMonth, getEndOfMonth } from './util/timestamp'
import { CalendarTimestamp } from 'vuetify/types'

/* @vue/component */
export default VCalendarWeekly.extend({
  name: 'v-calendar-monthly',
  props: {
    classPrefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    staticClass (): string {
      return `${this.classPrefix}v-calendar-monthly ${this.classPrefix}v-calendar-monthly`
    },
    parsedStart (): CalendarTimestamp {
      return getStartOfMonth(parseTimestamp(this.start, true))
    },
    parsedEnd (): CalendarTimestamp {
      return getEndOfMonth(parseTimestamp(this.end, true))
    },
  },

})
